// Define image max width for compression
export const IMAGE_MAX_WIDTH = 1200;
